<template>
  <div class="page-banner">
    <div class="container">
      <!-- <div class="network" v-if="event.networks[0]">
                <svg xmlns="http://www.w3.org/2000/svg" width="13.149" height="13.15" viewBox="0 0 13.149 13.15"><path class="a" d="M9.575,3A6.575,6.575,0,1,0,16.15,9.575,6.577,6.577,0,0,0,9.575,3ZM6.945,13.191a1.644,1.644,0,1,1,1.644-1.644A1.644,1.644,0,0,1,6.945,13.191Zm.986-6.246A1.644,1.644,0,1,1,9.575,8.589,1.644,1.644,0,0,1,7.931,6.945ZM12.2,13.191a1.644,1.644,0,1,1,1.644-1.644A1.644,1.644,0,0,1,12.2,13.191Z" transform="translate(-3 -3)"/></svg>
                <strong>{{ event.networks[0].network.name | truncate(15,'...') }}</strong>
            </div> -->
      <div
        class="image-wrapper"
        v-imagekit.background="{
          image: event.picture,
          transform: 'h-400,fo-auto'
        }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'event-page-header',

  props: {
    event: {
      type: Object,
      default() {
        return {};
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-banner {
  position: relative;
  color: var(--cs-gray-00);
  padding-top: 1px;
  text-align: center;
  background-color: var(--cs-primary-base);

  .container {
    position: relative;
    margin-bottom: 100px;
  }

  @include media-breakpoint-up(md) {
    text-align: left;
    padding-top: 25px;
  }

  h1 {
    font-size: 40px;
    font-weight: 700;
    padding-bottom: 40px;
    line-height: 1.4;
    @include media-breakpoint-up(md) {
      font-size: 44px;
      padding-bottom: 25px;
    }
  }

  time {
    display: block;
    font-size: 25px;
    margin-bottom: 10px;
    font-weight: 300;
  }

  .network {
    color: $grey;
    padding-bottom: 15px;
    font-size: 14px;
    font-weight: 700;

    @include media-breakpoint-up(md) {
      color: #ffffff;
      position: absolute;
      bottom: 0px;
      left: 34px;
      z-index: 1;
    }

    svg {
      margin-right: 7px;
      margin-bottom: 3px;
      path {
        fill: $grey;
        @include media-breakpoint-up(md) {
          fill: #ffffff;
        }
      }
    }
  }

  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: $secondary;
    z-index: -1;
    @include media-breakpoint-up(md) {
      height: 200px;
    }
    @include media-breakpoint-up(lg) {
      height: 250px;
    }
  }
}

.image-wrapper {
  position: relative;
  top: 100px;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-color: rgb(203, 203, 203);
  width: 100%;
  height: 175px;
  overflow: hidden;
  display: none;

  @include media-breakpoint-up(md) {
    display: block;
  }
  @include media-breakpoint-up(lg) {
    height: 249px;
  }
}
</style>
